// Chartkick draws through Chart.js. Chart.js must be a global before the adapter is used.
import Chart from "chart.js/auto"
import "chartkick/chart.js"

window.Chart = Chart
